import { startersApiService } from '../../services/startersApiService'

// Starters are static, so one fetch per key per session serves both the thumbnail and the modal.
const cache = new Map<string, Promise<Blob>>()

export function loadStarterPreview(key: string): Promise<Blob> {
  let p = cache.get(key)
  if (!p) {
    p = startersApiService.preview(key)
    p.catch(() => cache.delete(key))
    cache.set(key, p)
  }
  return p
}

export function clearStarterPreviewCache(): void {
  cache.clear()
}
